export default function ArrowActive() {
  return (
    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.78906 0.974609L9.11919 8.47461H0.458935L4.78906 0.974609Z" fill="#FFD085"/>
    </svg>
  )
}